import ct from 'countries-and-timezones';

// The country master stores only a display name — its `countryCode` field is a
// phone dial code (e.g. "+33"), NOT an ISO code. The `country-flag-icons`
// package needs an ISO 3166-1 alpha-2 code, so we resolve the country name
// against the built-in list in `countries-and-timezones`. A handful of common
// names/abbreviations the library doesn't match verbatim are mapped explicitly.
const ALIASES = {
    'usa': 'US',
    'u.s.a.': 'US',
    'united states': 'US',
    'united states of america': 'US',
    'uk': 'GB',
    'u.k.': 'GB',
    'great britain': 'GB',
    'united kingdom': 'GB',
    'united kingdom of great britain and northern ireland': 'GB',
    'south korea': 'KR',
    'north korea': 'KP',
    'russia': 'RU',
    'vietnam': 'VN',
    'ivory coast': 'CI',
    'czech republic': 'CZ',
    'czechia': 'CZ',
    'uae': 'AE',
    'united arab emirates': 'AE',
    'holland': 'NL',
    'netherlands': 'NL',
};

// Built lazily and cached: name (lowercased) -> ISO alpha-2 code.
let nameIndex = null;
const buildIndex = () => {
    if (nameIndex) return nameIndex;
    nameIndex = {};
    const all = ct.getAllCountries();
    Object.values(all).forEach((c) => {
        nameIndex[c.name.toLowerCase()] = c.id;
    });
    return nameIndex;
};

// Resolve a country name to an uppercase ISO 3166-1 alpha-2 code, or '' if the
// name can't be matched (callers should render a fallback in that case).
export const nameToIsoCode = (name) => {
    if (!name || typeof name !== 'string') return '';
    const key = name.trim().toLowerCase();
    if (!key) return '';
    if (ALIASES[key]) return ALIASES[key];
    const idx = buildIndex();
    return (idx[key] || '').toUpperCase();
};

export default nameToIsoCode;
